import React, { FC, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { BuildVersion, TWCPage } from '@components';

import { settingsMenuTestIDs, settingsPageTestIDs } from '@constants';
import { Route } from '@types';

import { SettingsBackground } from '../../components/settings/SettingsBackground/SettingsBackground';
import { SettingsContent } from '../../components/settings/SettingsContent/SettingsContent';
import { SettingsMenu } from '../../components/settings/SettingsMenu/SettingsMenu';

type SettingsPageProps = {
  route: Route;
};

export const SettingsPage: FC<SettingsPageProps> = ({ route }) => {
  const defaultActiveItem = route.params?.defaultActiveItem;
  const [activeMenuItem, setActiveMenuItem] = useState('account');
  const [additionalData, setAdditionalData] = useState({});
  const [accessRoute, setAccessRoute] = useState(false);

  useEffect(() => {
    if (defaultActiveItem && !accessRoute) {
      setActiveMenuItem(defaultActiveItem);
      setAdditionalData({ enableLocationPanel: true });
      setAccessRoute(true);
    } else {
      setAdditionalData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultActiveItem]);

  useEffect(() => {
    if (accessRoute) {
      setAdditionalData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem]);

  return (
    <TWCPage
      childIds={[
        settingsMenuTestIDs.account,
        settingsPageTestIDs.account.settingsAccountChangePlanButton,
        settingsPageTestIDs.account.settingsAccountInfo,
        settingsPageTestIDs.account.settingsAccountHelpSection,
        settingsMenuTestIDs.locations,
        settingsMenuTestIDs.alerts,
        settingsMenuTestIDs.closedCaptioning,
        settingsMenuTestIDs.help,
        settingsPageTestIDs.help.settingsHelp,
        settingsMenuTestIDs.privacyLegal,
        settingsPageTestIDs.privacyLegal.settingsPrivacyLegal,
        settingsMenuTestIDs.signOut,
        settingsMenuTestIDs.debug,
        settingsPageTestIDs.alerts.settingsAlertsSwitch,
        settingsPageTestIDs.closedCaptioning.settingsClosedCaptioningSwitch,
        settingsPageTestIDs.locations.settingsChangeLocationButton,
        settingsPageTestIDs.signOut.settingsSignOutButton,
        settingsPageTestIDs.debug.settingsDebugMenuButton,
      ]}
      firstFocus={defaultActiveItem || settingsMenuTestIDs.account}
      isMenuItem
      pageID={settingsPageTestIDs.settingsPage}
    >
      <SettingsBackground>
        <View style={styles.container}>
          <SettingsMenu activeMenuItem={activeMenuItem} setActiveMenuItem={setActiveMenuItem} />
          <SettingsContent activeMenuItem={activeMenuItem} additionalData={additionalData} />
        </View>
        <BuildVersion />
      </SettingsBackground>
    </TWCPage>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
});
